__webpack_require__.p = "/referrals-help/account-setup/";